'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(component) {
  return component.displayName || component.name;
}

function throttle(component, wait) {
  var Throttle = function (_Component) {
    _inherits(Throttle, _Component);

    function Throttle(props, context) {
      _classCallCheck(this, Throttle);

      var _this = _possibleConstructorReturn(this, (Throttle.__proto__ || Object.getPrototypeOf(Throttle)).call(this, props, context));

      _this.countDown = wait;
      _this.lastTime = Date.now();
      _this.timeout = null;
      _this.update = _this.update.bind(_this);
      return _this;
    }

    _createClass(Throttle, [{
      key: 'clearTimer',
      value: function clearTimer() {
        if (this.timeout !== null) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
      }
    }, {
      key: 'beforeUpdate',
      value: function beforeUpdate() {
        this.countDown = wait;
        this.lastTime = Date.now();
      }
    }, {
      key: 'update',
      value: function update() {
        this.beforeUpdate();
        this.timeout = null;
        this.forceUpdate();
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.update();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.clearTimer();
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate() {
        this.clearTimer();

        var now = Date.now();
        this.countDown -= now - this.lastTime;
        this.lastTime = now;

        if (this.countDown <= 0) {
          this.beforeUpdate();
          return true;
        } else {
          this.timeout = setTimeout(this.update, this.countDown);
          return false;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return (0, _react.createElement)(component, this.props);
      }
    }]);

    return Throttle;
  }(_react.Component);

  Throttle.displayName = getDisplayName(component);

  return (0, _hoistNonReactStatics2.default)(Throttle, component);
}

exports.default = throttle;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-throttle-render/lib/index.js
 ** module id = 1193
 ** module chunks = 23
 **/